var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.341,
    height: 188.341,
    viewBox: "0 0 188.341 188.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smile",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_406",
    "data-name": "Grupo 406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_403",
    "data-name": "Grupo 403",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_402",
    "data-name": "Grupo 402"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_145",
    "data-name": "Elipse 145",
    cx: 94.17,
    cy: 94.17,
    r: 94.17,
    fill: "#fed940"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_409",
    "data-name": "Grupo 409",
    transform: "translate(46.629 42.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_407",
    "data-name": "Grupo 407"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_146",
    "data-name": "Elipse 146",
    cx: 14.993,
    cy: 14.993,
    r: 14.993,
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_408",
    "data-name": "Grupo 408",
    transform: "translate(65.099)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_147",
    "data-name": "Elipse 147",
    cx: 14.993,
    cy: 14.993,
    r: 14.993,
    fill: "#634c4c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_410",
    "data-name": "Grupo 410",
    transform: "translate(39.07 98.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    "data-name": "Caminho 582",
    d: "M205.824,319.825a55.164,55.164,0,0,1-55.1-55.1h18.319a36.782,36.782,0,0,0,73.565,0h18.319A55.164,55.164,0,0,1,205.824,319.825Z",
    transform: "translate(-150.723 -264.724)",
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_583",
    "data-name": "Caminho 583",
    d: "M311.1,264.725H292.782A36.824,36.824,0,0,1,256,301.508h0v18.319h0A55.164,55.164,0,0,0,311.1,264.725Z",
    transform: "translate(-161.829 -165.987)",
    fill: "#634c4c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.69bd1ce43bbde183866056c92243c104.svg";
export { ForwardRef as ReactComponent };